<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { inject, type Ref } from 'vue';

import LocalizedEditor from './LocalizedEditor.vue';
import LocalizedVideoInput from './LocalizedVideoInput.vue';
import LocalizedInput from '../LocalizedInput.vue';

import type { Locales, LocalizableString } from '@/services/types/api.types';

const { t } = useI18n();

// PROPS
const props = defineProps<{
  name: string;
  label: string;
  language_enabled: Locales[];
  caption: LocalizableString;
  disableContent?: boolean;
  disableCaption?: boolean;
}>();

const editLocale = inject<Ref<Locales>>('editLocale');
</script>

<template>
  <localized-video-input
    :name="props.name"
    :label="props.label"
    :language_enabled="props.language_enabled"
    :caption="props.caption"
    type-name="config.videoType"
  >
    <q-field v-if="!props.disableContent" borderless :label="t('global.label.content')" stack-label>
      <template v-slot:control>
        <localized-editor
          name="config.content"
          :label="t('global.label.content')"
          class="q-mt-sm full-width"
          :editLocale="editLocale"
          :language_enabled="language_enabled"
        />
      </template>
    </q-field>
    <localized-input
      v-if="!props.disableCaption"
      name="config.videoCaption"
      :label="t('global.label.caption')"
      class="q-mt-sm full-width"
      :editLocale="editLocale"
      :language_enabled="language_enabled"
      outlined
    />
  </localized-video-input>
</template>
